import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const EmptyCart = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 10 }}>
            <ShoppingCartIcon sx={{ fontSize: '4rem', color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" gutterBottom>Your cart is empty!</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>Add items to it now.</Typography>
            <Button component={Link} to="/products" variant="contained" color="primary">Shop Now</Button>
        </Box>
    );
};

export default EmptyCart;
